import { Component, OnInit } from '@angular/core';

import { PasswordlessService } from '../../services/passwordless.service';

@Component({
  selector: 'app-passwordless-intermediate-page',
  templateUrl: './passwordless-intermediate-page.component.html',
  styleUrls: ['./passwordless-intermediate-page.component.scss'],
})
export class PasswordlessIntermediatePageComponent implements OnInit {
  constructor(private passwordlessService: PasswordlessService) {}

  ngOnInit(): void {
    this.passwordlessService.batchTier2SubmitPhase2();
  }
}
